import React, { useEffect } from 'react';
import { OrderPageContainer } from './OrderPage.styled';
import { SectionTitle } from './ContactPage.styled';
import { SEOHead } from '../components/SEOHead';

function OrderPage() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://embed.typeform.com/next/embed.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    return (
        <OrderPageContainer>
            <SEOHead
                title="Crea Tu Historia - Duo a Color Personalizado"
                description="Diseña tu pieza personalizada con Duo a Color. Totebags, cojines y accesorios con técnica punch needle. Artesanía única hecha a medida en España."
                path="/create-your-story"
            />
            <SectionTitle>Crea Tu Historia</SectionTitle>
            <div data-tf-live="01KAE3VYZA085W7VXYT2SVZS8X"></div>
        </OrderPageContainer>
    );
}

export default OrderPage;